const P = {
  base: "Mobile",
  sm: "Tablet",
  lg: "Desktop"
};
function d(t, b) {
  return b && Object.prototype.hasOwnProperty.call(b, t) ? b[t] : {};
}
const k = (t) => [
  "fontFamily",
  "fontSize",
  "fontWeight",
  "letterSpacing",
  "lineHeight"
].reduce(
  (f, l) => {
    var u, c, n;
    return f[l] = {
      /** object keys set as per typographyBreakpoints */
      base: (u = t == null ? void 0 : t.mobile) == null ? void 0 : u[l],
      sm: (c = t == null ? void 0 : t.tablet) == null ? void 0 : c[l],
      lg: (n = t == null ? void 0 : t.desktop) == null ? void 0 : n[l]
    }, f;
  },
  {}
);
export {
  k as getResponsiveTypography,
  d as getTypography,
  P as typographyBreakpoints
};
